import { render, staticRenderFns } from "./StudentLight.vue?vue&type=template&id=93bcda50&scoped=true&"
import script from "./StudentLight.vue?vue&type=script&lang=js&"
export * from "./StudentLight.vue?vue&type=script&lang=js&"
import style0 from "./StudentLight.vue?vue&type=style&index=0&id=93bcda50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bcda50",
  null
  
)

export default component.exports